module.exports = __webpack_public_path__ + "static/media/gallery7.56956344.webp";